import styled from "styled-components";

export const BalanceContainer = styled.div`
  margin: 15px;
`;

export const BalanceTopCard = styled.div`
  display: flex;
  justify-content: space-between;
  margin-block: 5px;
`;

export const BalanceTopCardButton = styled.button`
  display: flex;
  justify-content: space-evenly;
  border-radius: 15px;
  width: calc(100% - 10px);
  height: 35px;
  font-weight: bold;
  margin-inline: 5px;

  & > svg {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

export const BalanceCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #7b36ee;
  border-radius: 10px;
  padding: 10px 15px;
  margin-block: 50px 10px;
  background-color: ${({ theme }) => theme.colors.primary};
`;
